<head>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.1.0/css/all.css" integrity="sha384-lKuwvrZot6UHsBSfcMvOkWwlCMgc0TaWr+30HWe3a4ltaBwTZhyTEggF5tJv8tbt" crossorigin="anonymous">
  <link href="https://fonts.googleapis.com/css?family=Open+Sans" rel="stylesheet">
</head>

  <div style="margin-top: 10px;" class="col-sm-12">
      <button
      mat-stroked-button 
      (click) = "goBack()">
          <mat-icon>arrow_back</mat-icon> Back </button>
  </div>

  <br><br><br><br><br>
<div class="row">
  
</div>

<div class="container m-2">
<div class="row">
  
  <div class="PricText">
    <h1><strong>BLUE RATE CARD</strong></h1>
    <p style="text-align: center;">BLUE'S rate per hour will never be more than <strong>R100.00</strong> per consultant</p>
</div>
</div>
</div>




<div class="container m-2">
<div class="row">

<!-- html for the first eg -->
<div class="containerforall">

  <div class="MyCard">
    <div class="card-top background-purple">
      <!-- <p class="round1"></p> -->
      <h3></h3>
      <img class="image" src="assets/images/BLUE-Logo-Icon-Large.png" alt="Logo">
      <p class="card-tagline"><strong>Junior</strong></p>
      <p class="card-subtag"></p>
    </div>
    <div class="options">
      <ul class="option-list">
        <li class="option">
          <p>Basic Price</p>
          <span class="number">0-3</span>
          <span class="time-frame">months</span>
          <span class="cost">R50.00/h</span>
        </li>
        <li class="option ">
          <p>Normal Price</p>
          <span class="number">3-6</span>
          <span class="time-frame">months</span>
          <span class="cost">R40.00/h</span>
          
        </li>
        <li class="option">
          <p>Standard Price</p>
          <span class="number">6-9</span>
          <span class="time-frame">months</span>
          <span class="cost">R35.00/h</span>
        </li>
        <li class="option highlight-blue">
          <span class="pill">Super Popular</span>
          <p>Premium</p>
          <span class="number">12+</span>
          <span class="time-frame">months</span>
          <span class="cost" style="color: red;">R30.00/h</span>
          <span class="savings">25% Savings</span>
        </li>
      </ul>
    </div>
    <!-- <div class="cta">
      <a class="btn btn-purple" href="#">Learn More</a>
      <a class="decline" href="#">No thanks</a>
    </div> -->
  </div>
  <div class="MyCard">
    <div class="card-top background-red">
      <!-- <p class="round2"></p> -->
      <h3></h3>
      <img class="image" src="assets/images/BLUE-Logo-Icon-Large.png" alt="Logo">
      <p class="card-tagline"><strong>Intermediate</strong></p>
      <p class="card-subtag"></p>
    </div>
    <div class="options">
      <ul class="option-list">
        <li class="option">
          <p>Basic Price</p>
          <span class="number">0-3</span>
          <span class="time-frame">months</span>
          <span class="cost">R75.00/h</span>
        </li>
        <li class="option">
          <p>Normal price</p>
          <span class="number">3-6</span>
          <span class="time-frame">months</span>
          <span class="cost">R69.00/h</span>
          
        </li>
        <li class="option">
          <p>Standard Price</p>
          <span class="number">6-9</span>
          <span class="time-frame">months</span>
          <span class="cost">R60.00/h</span>
        </li>
        <li class="option highlight-blue">
          <P>Premium</P>
          <span class="pill">Super Popular</span>
          <span class="number">12+</span>
          <span class="time-frame">months</span>
          <span class="cost" style="color: red;">R50.00/h</span>
          <span class="savings">25% Savings</span>
        </li>
      </ul>
    </div>
    <!-- <div class="cta">
      <a class="btn btn-red" href="#">Learn More</a>
       <a class="decline" href="#">No thanks</a>
    </div> -->
  </div>

  <div class="MyCard">
    <div class="card-top background-teal">
      <!-- <p class="round3"></p> -->
      <h3></h3>
      <img class="image" src="assets/images/BLUE-Logo-Icon-Large.png" alt="Logo">
      <p class="card-tagline"><strong>Senior</strong></p>
      <p class="card-subtag"></p>
    </div>
    <div class="options">
      <ul class="option-list">
        <li class="option">
          <p>Basic Price</p>
          <span class="number">0-3</span>
          <span class="time-frame">months</span>
          <span class="cost">R100.00/h</span>
        </li>
        <li class="option">
          <p>Normal Price</p>
          <span class="number">3-6</span>
          <span class="time-frame">months</span>
          <span class="cost">R90.00/h</span>
          
        </li>
        <li class="option">
          <p>Standard Price</p>
          <span class="number">6-9</span>
          <span class="time-frame">months</span>
          <span class="cost">R80.00/h</span>
        </li>
        <li class="option highlight-blue">
          <span class="pill">Super Popular</span>
          <p>Premium</p>
          <span class="number">12+</span>
          <span class="time-frame">months</span>
          <span class="cost" style="color: red;">R70.00/h</span>
          <span class="savings">25% Savings</span>
        </li>
      </ul>
    </div>
    <!-- <div class="cta">
      <a class="btn btn-teal" href="#">Learn More</a>
       <a class="decline" href="#">No thanks</a> 
    </div> -->
  </div>

</div>


</div>
</div>

<br><br><br><br><br>


<!-- <div class="card-body mb-2 align-items-center"> -->




<div class="container m-2">
    <div class="row">
      
      <h3 class="text-black text-center heading "><strong>Here is how it works!</strong></h3> 
     
    </div>
</div>
         
  <!-- <h3 class="text-black text-center heading "><strong>Here is how it works!</strong></h3>  -->


<div class="container m-2">
<div class="row">
  <div class="col-md-4">
      <!-- Content for card 1 in container 1 -->
      
        <div class="card" style="">
            <div class="card-body">



              <div class="horizontal-container">
           
    
                <div class="MonyPcs">
                  <img src="assets/money.png" alt="Icon Image" class="icon-image">
              <p class="text-lead" style="color:  #017DB5"> Junior </p>       
              <p>Consultant Rate : R300</p>    
                </div>
  
  
                <div class="SignCard">
                  <img class="SignImage" style="width: 20px; height: 20px; margin-left: 60px;" src="assets/images/add.png">
              </div> 
  
  
            </div>
            <!-- <hr>  -->
              
        </div>
        </div>
  </div>
  <div class="col-md-4">
    <div class="card" style="">
        <div class="card-body">
           
          <div class="horizontal-container">
           
            <div class="MonyPcs">
              <img src="assets/money.png" alt="Icon Image" class="icon-image">
              <p class="text-lead" style="color:  #017DB5"> Blue </p>       
              <p>Blue Commission  : R50 </p>   
            </div>


            <div class="SignCard" >
              <img class="SignImage"  style="width: 20px; height: 20px; margin-left: 60px;" src="assets/images/equals.png">
          </div> 


        </div>
        <!-- <hr> -->

        </div>
    </div>
  </div>

  <div class="col-md-4">
    <div class="card" style="">
        <div class="card-body">
          
          <img src="assets/money.png" alt="Icon Image" class="icon-image">
          <p class="text-lead" style="color:  #017DB5"> Total </p>       
          <p> Final Cost  : R350</p>  
          <!-- <hr> -->
        </div>
      </div>
   </div>
 </div>
</div>


<br><br><br><br><br>

<style>
 

/* css for the first eg */

.containerforall{
display: flex;
flex-wrap: wrap;
font-family: 'Open Sans', sans-serif;
}

.MyCard {
border-radius: 10px;
box-shadow: 0px 0px 50px #ccc;
width: 350px;
text-align: center;
margin-left: 2em;
margin-top: 2em;

a{
  text-decoration: none;
  color: black;
}

.card-top{
  color: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-size: 1.5em;
  min-height: 200px;
  padding-bottom: 0.5em;
  
  span{
    color: #fafafa;
    font-size: 0.6em;
    padding-top: 1em;
  }
}

.background-purple {
  background: #017DB5;
  background: #017DB5;
}

.background-red {
  background: #017DB5;
  background: #017DB5;
}

.background-teal{
  background: #017DB5;
  background: #017DB5;
}


h3{
  font-size: 16px*1.75;
  font-weight: 400;
  margin: 0;
  padding: 2rem 0 0;
}

i{
  font-size: 16px*3.5;
  padding: 1.25rem 0 0;
}

.card-tagline {
  font-size: 16px*1.25;
  margin: 0;
  padding: 1.25rem 0 0;
}

.card-subtag{
  color: hsla(100%, 100%, 100%, 0.9); 
  font-size: 16px*0.75;
}

span {
  display: block;
  width: 100%;
}

.option-list {
  background-color: #F4F4F4;
  display: flex;
  list-style: none;
  justify-content: space-between;
  padding: 0em 0;
  margin: 0;
  width: 75%;    
  
  .option {
    border: solid 2px hsla(240, 23%, 97%, 0);
    padding: 1em;
    padding-bottom: 0.5em;
    position: relative;
    width: calc(1/3 * 100%);  
  }
  
   .highlight-blue{
      border: 2px solid blue;
      box-shadow: 0px 0px 10px blue;
      margin: 0; 
       
      span {
         color: blue;
      }
       
       .savings {
         color: lighten(blue, 15%);
       }
    
    .pill {
      background-color: blue;
      border-radius: 20px;
      box-shadow: 0px 0px 25px blue;
      color: #fff;
      display: block;
      line-height: 1.5em;
      font-size: 0.75em;
      position: absolute;
      top: -10px;
      margin: 0 auto;
      width: 75%;
      }
    } 
  
  .highlight-red {
      border: 2px solid red;
      box-shadow: 0px 0px 10px red;
      margin: 0; 
       
      span {
         color: red;
      }
       
       .savings {
         color: lighten(red, 15%);
       }
    
    .pill {
      background-color: #017DB5;
      border-radius: 20px;
      box-shadow: 0px 0px 25px red;
      color: #fff;
      display: block;
      line-height: 1.5em;
      font-size: 0.75em;
      position: absolute;
      top: -10px;
      margin: 0 auto;
      width: 75%;
      } 
  }
  
  .highlight-green {
      border: 2px solid green;
      box-shadow: 0px 0px 10px green;
      margin: 0; 
       
      span {
         color: green;
      }
       
       .savings {
         color: lighten(green, 15%);
       }
    
    .pill {
      background-color: green;
      border-radius: 20px;
      box-shadow: 0px 0px 25px green;
      color: #fff;
      display: block;
      line-height: 1.5em;
      font-size: 0.75em;
      position: absolute;
      top: -10px;
      margin: 0 auto;
      width: 75%;
      } 
  }
  
  .popular {
    display: none;
  }
  
  .number {
    font-size: 2em;
  }
  
  .time-frame {
    font-size: 0.95em;
  }
  
  .cost {
    font-size: 0.75em;
    font-weight: 800;
  }
  
  .savings {
    font-size: 0.75em;
    padding: 0.5em 0 0;
  }
} 

.cta{
  padding: 1em 0;

  
  .btn {
    border-radius: 25px;
    box-shadow: 0px 0px 25px #c6c6c6;
    color: #fff;
    display: block;
    margin: 0 auto;
    padding: 10px 0;
    text-decoration: none;
    width: 75%;
  }
  
  .btn-purple {
    background: linear-gradient(90deg, #5f23ae 0%, #8440be 31%, #c86dd7 100%);
    background-size: 150% auto;
    background-position: 31% 0;
    transition: background-position 0.4s;
    
    &:hover{
        background-position: 100% 0;
      }
  }
  
  .btn-red {
    background: linear-gradient(90deg, #AF1310 0%, #DE3A37 50%, #FF4441 100%);
    background-size: 150% auto;
    background-position: 31% 0;
    transition: background-position 0.4s;
    
    &:hover{
        background-position: 100% 0;
      }
  }
  
   .btn-teal {
    background: linear-gradient(90deg, #1B8B77 0%, #38BDA6 50%, #60E6C0 100%);
    background-size: 150% auto;
    background-position: 31% 0;
    transition: background-position 0.4s;
    
    &:hover{
        background-position: 100% 0;
      }
  }
  
  .decline {
    color: #C9C9C9;
    font-weight: 700;
    display: block;
    padding: 1em 0 0;
    margin: auto;
    text-decoration: none;
    text-transform: uppercase;
    transition: color 0.3s ease;
    width: 40%;
    
      &:hover{
        color: #999;
      }
  }
}
}


p.round1 {
border: 2px solid white;
border-radius: 12px;
padding: 5px;
background-color: black;
}

p.round2 {
border: 2px solid white;
border-radius: 12px;
padding: 5px;
background-color: green;
}

p.round3 {
border: 2px solid white;
border-radius: 12px;
padding: 5px;
background-color: gold;
}


.PricText h1{
  text-align: center;
}


.SignCard{
  /* margin-right: 15px; */

}

.SignImage{
  width: 10px;
height: 10px;
}

.cost{
  color: red;
}




.horizontal-container {
  display: flex;
  align-items: center;
  gap: 20px; /* Adjust gap between elements if needed */
}
</style>